import { Moon, Sun } from 'lucide-react'
import { useTheme } from './ThemeProvider'

interface ThemeToggleProps {
  className?: string
}

export function ThemeToggle({ className = '' }: ThemeToggleProps) {
  const { theme, toggleTheme } = useTheme()

  return (
    <button
      onClick={toggleTheme}
      aria-label={`Switch to ${theme === 'dark' ? 'light' : 'dark'} theme`}
      className={`
        relative inline-flex items-center justify-center
        w-8 h-8 rounded-md
        text-[var(--sidebar-text)] hover:text-[var(--sidebar-text-hover)]
        hover:bg-[var(--interactive-secondary-hover)]
        transition-colors duration-150
        focus-visible:outline-2 focus-visible:outline-[var(--brand-coral)]
        ${className}
      `}
    >
      {theme === 'dark' ? (
        <Sun size={16} strokeWidth={1.75} />
      ) : (
        <Moon size={16} strokeWidth={1.75} />
      )}
    </button>
  )
}
